import { render, staticRenderFns } from "./myStaffList.vue?vue&type=template&id=31cf4ee4&"
import script from "./myStaffList.vue?vue&type=script&lang=js&"
export * from "./myStaffList.vue?vue&type=script&lang=js&"
import style0 from "./myStaffList.vue?vue&type=style&index=0&id=31cf4ee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports